import * as React from "react";
const SvgArrowThin = (props) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18 12L14 16L18 20", stroke: "#3D4C66", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgArrowThin;
